import { useQuery } from '@tanstack/react-query';
import { EDUCATION_HISTORIES } from 'src/utils/constants/queryKeys';
import { getEducationHistories } from '../services/fn-api/Beneficiary';

export const useGetEducationHistories = (beneId: number) => {
  return useQuery({
    queryKey: [EDUCATION_HISTORIES, beneId],
    queryFn: () => getEducationHistories(beneId),
    enabled: !!beneId,
  });
};
